<template>
  <button
    :disabled="disabled"
    class="
      tw-uppercase
      tw-tracking-widest
      tw-py-2
      tw-px-6
      tw-rounded-md
      tw-cursor-pointer
      tw-select-none
      tw-inline-block
      tw-font-medium
    "
    :class="{
      'tw-text-xs': small,
      'tw-text-white': !inverted,
      'tw-bg-[#4164E3]': !inverted,
      'tw-text-[#4164E3]': inverted,
      'tw-bg-white': inverted,
      'tw-border-[#4164E3]': inverted,
      border: inverted,
      'tw-opacity-30': disabled,
    }"
    @click="$emit('click')"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
    },
    disabled: {
      default: false,
      required: false,
      type: Boolean,
    },
    inverted: {
      type: Boolean,
    },
  },
}
</script>

<style></style>
